import { CheckCircle2, Clock, Eye, XCircle, CircleDot } from 'lucide-react';

const STATUS_STYLE = {
  pending: { cls: 'bg-gray-100 text-gray-600 border-gray-200', Icon: Clock, label: 'Pending' },
  sent: { cls: 'bg-blue-50 text-blue-700 border-blue-100', Icon: CircleDot, label: 'Sent' },
  viewed: { cls: 'bg-amber-50 text-amber-700 border-amber-100', Icon: Eye, label: 'Viewed' },
  signed: { cls: 'bg-green-50 text-green-700 border-green-100', Icon: CheckCircle2, label: 'Signed' },
  declined: { cls: 'bg-red-50 text-red-700 border-red-100', Icon: XCircle, label: 'Declined' },
};

export default function RecipientStatusPills({ recipients, max = 3 }) {
  if (!recipients || recipients.length === 0) {
    return <span className="text-xs text-gray-400">No recipients</span>;
  }
  const visible = recipients.slice(0, max);
  const rest = recipients.length - visible.length;

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {visible.map((r) => {
        const style = STATUS_STYLE[r.status] || STATUS_STYLE.pending;
        const { Icon } = style;
        return (
          <span
            key={r.id || r.email}
            className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${style.cls}`}
            title={`${r.name || r.email} — ${style.label}`}
          >
            <Icon className="w-3 h-3" />
            <span className="max-w-[110px] truncate">{r.name || r.email}</span>
          </span>
        );
      })}
      {rest > 0 && (
        <span className="text-xs text-gray-500 ml-1">+{rest} more</span>
      )}
    </div>
  );
}
